import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveMrbFailure, saveMrbSuccess, updateMrbFailure, updateMrbSuccess } from './actions';

export function* saveMrb({ payload }) {
  try {
    yield call(api.post, 'api/mrb', payload.data, { withCredentials: true });

    yield put(saveMrbSuccess());

    toast.success('MRB criado com sucesso!')

    history.push('/specifications/pilar3/resources/mrb');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveMrbFailure());
  }
}

export function* updateMrb({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/mrb/${id}`, payload.data, { withCredentials: true });

    yield put(updateMrbSuccess());

    toast.success('MRB atualizado com sucesso!')

    history.push('/specifications/pilar3/resources/mrb');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateMrbFailure());
  }
}

export default all([
  takeLatest('@mrb/SAVE_REQUEST', saveMrb),
  takeLatest('@mrb/UPDATE_REQUEST', updateMrb)
]);